package com.macrofocus.nastac.ui.layer

import deckgl.DataFilterExtension
import deckgl.MVTLayer
import js.objects.unsafeJso

fun createCShapesEuropeLayer(visible: Boolean, year: Int) : MVTLayer<Any> {
    val FILTERING = true

    val shape = MVTLayer<Any>(unsafeJso {
        if(FILTERING) {
            id = "cshapesEurope"
            this.data = "/martin/cshapesEurope"
        } else {
            id = "cshapesEurope-$year"
            this.data = "/martin/cshapesEurope/${year}"
        }

        this.visible = visible

        pickable = true

        asDynamic().stroked = true
        asDynamic().filled = false
        asDynamic().extruded = false
//        lineWidthScale = 20
        asDynamic().lineWidthMinPixels = 2
        asDynamic().lineWidthMaxPixels = 8
        asDynamic().getFillColor = null
        asDynamic().getLineColor = { d : dynamic -> arrayOf(0,0,0, 200) }
        asDynamic().getLineWidth = 10000
        asDynamic().getElevation = 30

        if(FILTERING) {
            asDynamic().getFilterValue = { d: dynamic ->
                val from = (d.properties.From as? Number)?.toInt()
                val to = (d.properties.To as? Number)?.toInt()
                if (from != null && to != null && year >= from && year <= to) 1.0 else 0.0
            }
            asDynamic().filterRange = arrayOf(1.0, 1.0)
            updateTriggers = unsafeJso {
                this.asDynamic().getFilterValue = arrayOf(year)
            }

            extensions = arrayOf(DataFilterExtension(unsafeJso {
                filterSize = 1
            }))
        }
    })
    return shape
}